import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onAssessmentStart, onLearnMore }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-card rounded-xl border border-border p-6 transition-all duration-300 hover:elevation-moderate">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${service.iconBg}`}>
            <Icon name={service.icon} size={24} className={service.iconColor} />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-text-primary">{service.title}</h3>
            <p className="text-sm text-text-secondary">{service.subtitle}</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${service.badgeStyle}`}>
            {service.badge}
          </span>
        </div>
      </div>

      <p className="text-text-secondary mb-4 leading-relaxed">
        {service.description}
      </p>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center space-x-2 mb-1">
            <Icon name="Target" size={16} className="text-accent" />
            <span className="text-sm font-medium text-text-primary">Focus Area</span>
          </div>
          <p className="text-sm text-text-secondary">{service.focusArea}</p>
        </div>
        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center space-x-2 mb-1">
            <Icon name="TrendingUp" size={16} className="text-success" />
            <span className="text-sm font-medium text-text-primary">Avg. Impact</span>
          </div>
          <p className="text-sm text-text-secondary">{service.avgImpact}</p>
        </div>
      </div>

      <div className="space-y-3 mb-4">
        <h4 className="text-sm font-semibold text-text-primary">Key Capabilities:</h4>
        <div className="grid grid-cols-1 gap-2">
          {service.capabilities.slice(0, isExpanded ? service.capabilities.length : 3).map((capability, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={14} className="text-success flex-shrink-0" />
              <span className="text-sm text-text-secondary">{capability}</span>
            </div>
          ))}
        </div>
        {service.capabilities.length > 3 && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-sm text-accent hover:text-accent/80 font-medium transition-colors"
          >
            {isExpanded ? 'Show Less' : `Show ${service.capabilities.length - 3} More`}
          </button>
        )}
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="outline"
          size="sm"
          iconName="Activity"
          iconPosition="left"
          onClick={() => onAssessmentStart(service.id)}
          className="flex-1"
        >
          Start Assessment
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={() => onLearnMore(service.id)}
          className="flex-1"
        >
          Learn More
        </Button>
      </div>
    </div>
  );
};

export default ServiceCard;